const DEFAULT_APP_BASE_URL = 'https://prosperitymentors.net';

/** Resolve public app origin for absolute CTA links. */
export function resolveAppBaseUrl(appBaseUrl) {
  const fromArg = (appBaseUrl || '').trim().replace(/\/$/, '');
  if (fromArg) return fromArg;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return DEFAULT_APP_BASE_URL;
}

/**
 * Registration URL for landing CTAs: {origin}/register/{event_id}[?ref=...]
 * Path is always /register/ — never /landing/.
 */
export function buildLandingCtaUrl(eventId, options = {}) {
  const id = eventId != null ? String(eventId).trim() : '';
  if (!id) return options.fallback || '#';

  const base = resolveAppBaseUrl(options.appBaseUrl);
  const ref = options.refSlug ?? options.ref ?? null;
  const path = ref
    ? `/register/${id}?ref=${encodeURIComponent(ref)}`
    : `/register/${id}`;

  return `${base}${path}`;
}

/** Resolve CTA label from event language. */
export function resolveCtaText(event) {
  const fromEvent = event?.cta_text && String(event.cta_text).trim();
  if (fromEvent) return fromEvent;
  const lang = (event?.language || '').toLowerCase();
  return lang === 'es' ? 'Regístrate Ahora' : 'Register Now';
}
